{
  "_comment": "Shared chat tenant configuration. The backend reads this file at runtime; the frontend bundles it through the @tenants alias. Prompts live in apps/shared_backend/app/system_prompt.py. The Medical Repository owns study data.",
  "default": "all",
  "tenants": {
    "all": {
      "label": "Alle Fachgebiete",
      "displayName": "Ivelion AI – Studienfinder",
      "logo": "/Logo_1.png",
      "promptScope": "general",
      "conditionsHint": "alle Erkrankungen und Fachgebiete (in CTIS gelistete und von Studienteams hinzugefügte Studien)",
      "categories": [
        {
          "id": "arztbesuch",
          "label": "Arztbesuchsplanung",
          "icon": "Stethoscope",
          "suggestions": [
            {
              "label": "Vorbereitung für den nächsten Arztbesuch",
              "message": "Ich habe bald einen Arzttermin. Können Sie mir helfen, mich darauf vorzubereiten? Welche Fragen sollte ich stellen?"
            },
            {
              "label": "Arztbericht verstehen",
              "message": "Ich habe einen Arztbericht erhalten und verstehe einige Begriffe nicht. Können Sie mir helfen, medizinische Fachbegriffe zu verstehen?"
            },
            {
              "label": "Symptome verstehen und einordnen",
              "message": "Wie kann ich meine Symptome besser verstehen und einordnen? Was bedeuten sie für mich?"
            }
          ]
        },
        {
          "id": "studien",
          "label": "Klinische Studien",
          "icon": "Beaker",
          "suggestions": [
            {
              "label": "Passende Studie finden",
              "message": "Ich möchte an einer klinischen Studie teilnehmen. Wie finde ich eine passende Studie für meine Erkrankung?"
            },
            {
              "label": "Studien in meiner Nähe",
              "message": "Welche klinischen Studien für meine Erkrankung gibt es in meiner Nähe? Ich nenne Ihnen gleich meine Postleitzahl und meine Erkrankung."
            },
            {
              "label": "Ablauf einer Studie",
              "message": "Wie läuft eine klinische Studie ab? Was erwartet mich als Teilnehmer?"
            }
          ]
        },
        {
          "id": "gesundheit",
          "label": "Meine Gesundheit",
          "icon": "Sparkles",
          "suggestions": [
            {
              "label": "Behandlungsmöglichkeiten",
              "message": "Welche Behandlungsmöglichkeiten gibt es für meine Erkrankung? Was sind die neuesten Therapieansätze?"
            },
            {
              "label": "Unterstützung und Ressourcen",
              "message": "Wo finde ich Unterstützung und Ressourcen für meine Erkrankung? Gibt es Selbsthilfegruppen?"
            },
            {
              "label": "Informationen zu einem Forschungsprojekt",
              "message": "Bitte teilen Sie Informationen zu einem bestimmten Forschungsprojekt mit mir."
            }
          ]
        }
      ]
    },
    "neuro": {
      "label": "Neurologie",
      "displayName": "Ivelion AI – Neurologie",
      "logo": "/Logo_1.png",
      "conditionsHint": "verschiedene neurologische Erkrankungen",
      "categories": [
        {
          "id": "arztbesuch",
          "label": "Arztbesuchsplanung",
          "icon": "Stethoscope",
          "suggestions": [
            {
              "label": "Vorbereitung für den nächsten Arztbesuch",
              "message": "Ich habe bald einen Arzttermin. Können Sie mir helfen, mich darauf vorzubereiten? Welche Fragen sollte ich stellen?"
            },
            {
              "label": "Arztbericht verstehen",
              "message": "Ich habe einen Arztbericht erhalten und verstehe einige Begriffe nicht. Können Sie mir helfen, medizinische Fachbegriffe zu verstehen?"
            },
            {
              "label": "Informationen zum Forschungsprojekt",
              "message": "Bitte teilen Sie Informationen zu diesem Forschungsprojekt mit mir."
            }
          ]
        },
        {
          "id": "neurologie",
          "label": "Meine Erkrankung",
          "icon": "Brain",
          "suggestions": [
            {
              "label": "Behandlungsmöglichkeiten",
              "message": "Welche Behandlungsmöglichkeiten gibt es für meine Erkrankung? Was sind die neuesten Therapieansätze?"
            },
            {
              "label": "Symptome verstehen und einordnen",
              "message": "Wie kann ich meine Symptome besser verstehen und einordnen? Was bedeuten sie für mich?"
            },
            {
              "label": "Unterstützung und Ressourcen",
              "message": "Wo finde ich Unterstützung und Ressourcen für meine Erkrankung? Gibt es Selbsthilfegruppen?"
            }
          ]
        },
        {
          "id": "studien",
          "label": "Klinische Studien",
          "icon": "Beaker",
          "suggestions": [
            {
              "label": "Passende Studie finden",
              "message": "Ich möchte an einer klinischen Studie teilnehmen. Wie finde ich eine passende Studie für meine Erkrankung?"
            },
            {
              "label": "Aktuelle verfügbare Studien",
              "message": "Welche klinischen Studien für meine Erkrankung sind derzeit im System verfügbar? Können Sie mir eine Übersicht geben?"
            },
            {
              "label": "Ablauf einer Studie",
              "message": "Wie läuft eine klinische Studie ab? Was erwartet mich als Teilnehmer?"
            }
          ]
        }
      ]
    },
    "derma": {
      "label": "Dermatologie",
      "displayName": "Ivelion AI – Dermatologie",
      "logo": "/Logo_1.png",
      "conditionsHint": "verschiedene dermatologische Erkrankungen wie Psoriasis, atopische Dermatitis (Neurodermitis), Hauttumoren, Vitiligo und weitere Hauterkrankungen",
      "categories": [
        {
          "id": "arztbesuch",
          "label": "Arztbesuchsplanung",
          "icon": "Stethoscope",
          "suggestions": [
            {
              "label": "Vorbereitung für den nächsten Arztbesuch",
              "message": "Ich habe bald einen Arzttermin. Können Sie mir helfen, mich darauf vorzubereiten? Welche Fragen sollte ich stellen?"
            },
            {
              "label": "Arztbericht verstehen",
              "message": "Ich habe einen Arztbericht erhalten und verstehe einige Begriffe nicht. Können Sie mir helfen, medizinische Fachbegriffe zu verstehen?"
            },
            {
              "label": "Informationen zum Forschungsprojekt",
              "message": "Bitte teilen Sie Informationen zu diesem Forschungsprojekt mit mir."
            }
          ]
        },
        {
          "id": "dermatologie",
          "label": "Meine Hauterkrankung",
          "icon": "Sparkles",
          "suggestions": [
            {
              "label": "Behandlungsmöglichkeiten",
              "message": "Welche Behandlungsmöglichkeiten gibt es für meine Hauterkrankung? Was sind die neuesten Therapieansätze?"
            },
            {
              "label": "Symptome verstehen und einordnen",
              "message": "Wie kann ich meine Hautsymptome besser verstehen und einordnen? Was bedeuten sie für mich?"
            },
            {
              "label": "Unterstützung und Ressourcen",
              "message": "Wo finde ich Unterstützung und Ressourcen für meine Hauterkrankung? Gibt es Selbsthilfegruppen?"
            }
          ]
        },
        {
          "id": "studien",
          "label": "Klinische Studien",
          "icon": "Beaker",
          "suggestions": [
            {
              "label": "Passende Studie finden",
              "message": "Ich möchte an einer klinischen Studie teilnehmen. Wie finde ich eine passende Studie für meine Hauterkrankung?"
            },
            {
              "label": "Aktuelle verfügbare Studien",
              "message": "Welche klinischen Studien für meine Hauterkrankung sind derzeit im System verfügbar? Können Sie mir eine Übersicht geben?"
            },
            {
              "label": "Ablauf einer Studie",
              "message": "Wie läuft eine klinische Studie ab? Was erwartet mich als Teilnehmer?"
            }
          ]
        }
      ]
    }
  }
}
